// GENERATED by @platform/contracts from specs/platform/main.tsp. Do not edit; run `pnpm generate`.
/* eslint-disable */
import { createCaller } from '../../client/runtime.js';
import { operations } from './schemas.js';
export function createPlatformClient(options) {
    const call = createCaller(options);
    return {
        /** Platform-staff users of the control-plane pool. */
        Admins_list: (input = {}) => call(operations.Admins_list, input),
        /** Invite a platform-staff user: creates them in the control-plane pool (TOTP required at first sign-in). */
        Admins_create: (input) => call(operations.Admins_create, input),
        /** Remove a platform-staff user. Never oneself. */
        Admins_remove: (input) => call(operations.Admins_remove, input),
        /** One platform-staff user. */
        Admins_get: (input) => call(operations.Admins_get, input),
        /** Announcements, newest first. */
        Announcements_list: (input = {}) => call(operations.Announcements_list, input),
        /**
         * Show a notice to the people of a tenant, one person, or every active tenant of a cell. Sent
         * to each tenant's cell; audited on each tenant's log.
         */
        Announcements_publish: (input) => call(operations.Announcements_publish, input),
        /** Take an announcement back: the apps stop showing it. Idempotent. */
        Announcements_withdraw: (input) => call(operations.Announcements_withdraw, input),
        /** Every cell the directory routes to, with hostnames and tenant counts. */
        Cells_list: (input = {}) => call(operations.Cells_list, input),
        /** Where a workspace lives: its cell and app hostname. 404 until the tenant is provisioned. */
        Directory_get: (input) => call(operations.Directory_get, input),
        /** The platform menu definition: every item with the action and feature that gate it. */
        Menu_get: (input = {}) => call(operations.Menu_get, input),
        /** Ingest usage records for a tenant (stub: stored, not yet aggregated). Cells use the bus. */
        Metering_ingest: (input) => call(operations.Metering_ingest, input),
        /** Usage per tenant over one UTC month or day, summed per metric; `tenantId` narrows it to one tenant. */
        Metering_usage: (input) => call(operations.Metering_usage, input),
        /** List catalog packages, retired ones included when asked. */
        Packages_list: (input = {}) => call(operations.Packages_list, input),
        /** Create a package at version 1. */
        Packages_create: (input) => call(operations.Packages_create, input),
        /** Read a package at its current version. */
        Packages_get: (input) => call(operations.Packages_get, input),
        /** Edit a package. Bumps `version`; no tenant snapshot changes. */
        Packages_update: (input) => call(operations.Packages_update, input),
        /** Retire a package: no new adoptions. Existing snapshots are untouched. */
        Packages_retire: (input) => call(operations.Packages_retire, input),
        /** Every product the platform sells, one per `products/<name>/product.yaml`. */
        Products_list: (input = {}) => call(operations.Products_list, input),
        /** Self-serve signup: reserves the slug and starts onboarding (pay first, then provision). */
        Signup_request: (input) => call(operations.Signup_request, input),
        /** Is this slug free? */
        Signup_availability: (input) => call(operations.Signup_availability, input),
        /**
         * Packages a self-serve visitor of one product may pick: pool tier, not retired. No prices
         * (Checkout carries them). `product` absent reads as `sprocket` until every sign-up page sends it.
         */
        Signup_catalog: (input = {}) => call(operations.Signup_catalog, input),
        /**
         * The documents a person accepts to sign up for one product, at their current versions, with
         * where to read them. Empty: the product asks for none.
         */
        Signup_documents: (input) => call(operations.Signup_documents, input),
        /**
         * Personal sign-up: the caller has already created and confirmed their identity in a cell pool
         * of the package's product and presents its ID token as `Authorization: Bearer`; the handler
         * verifies it against the directory's cell issuers (the gateway does not). Starts the same
         * pay-first onboarding as `request`. The tenant id is derived from the product and the
         * person, so a repeat resumes it. Poll with `status` using the returned `slug`.
         */
        Signup_personal: (input) => call(operations.Signup_personal, input),
        /** Poll onboarding progress for a slug. Reveals status only, never tenant data. */
        Signup_status: (input) => call(operations.Signup_status, input),
        /** List tenants in the registry. */
        Tenants_list: (input = {}) => call(operations.Tenants_list, input),
        /** Onboard a tenant (sales-led). Starts the onboarding workflow; returns 202 with the registry entry in `pendingPayment`. */
        Tenants_create: (input) => call(operations.Tenants_create, input),
        /** Read one tenant registry entry, including its entitlement snapshot. */
        Tenants_get: (input) => call(operations.Tenants_get, input),
        /** Update name or flags. Tier, package and status have their own operations. */
        Tenants_update: (input) => call(operations.Tenants_update, input),
        /** Start offboarding. Data is retained per the retention policy until deprovisioning completes. */
        Tenants_offboard: (input) => call(operations.Tenants_offboard, input),
        /** The onboarding workflow's state for a tenant: stage, attempt, execution, checkout, failure. */
        Tenants_onboarding: (input) => call(operations.Tenants_onboarding, input),
        /** Adopt a package: snapshots the package's current version onto the tenant. */
        Tenants_adoptPackage: (input) => call(operations.Tenants_adoptPackage, input),
        /**
         * Re-apply the tenant's package: replaces the snapshot with the package's current version.
         * The only way a catalog edit reaches a tenant. Explicit, audited, never implicit.
         */
        Tenants_reapplyPackage: (input) => call(operations.Tenants_reapplyPackage, input),
        /** Lift a suspension. */
        Tenants_resume: (input) => call(operations.Tenants_resume, input),
        /** Retry a failed onboarding: starts a new workflow attempt. 409 unless the tenant is `failed`. */
        Tenants_retry: (input) => call(operations.Tenants_retry, input),
        /** Suspend sign-in for every user of the tenant. Data is untouched. */
        Tenants_suspend: (input) => call(operations.Tenants_suspend, input),
        /** Change the tenant's tier. Moving to silo starts a cell provisioning job; returns 202. */
        Tenants_changeTier: (input) => call(operations.Tenants_changeTier, input),
        /** The tiers this cell offers and their limits. */
        Tiers_list: (input = {}) => call(operations.Tiers_list, input),
        /** The caller's own workspace: name, tier, status, entitlement. */
        Workspaces_get: (input = {}) => call(operations.Workspaces_get, input),
        /** Packages the caller's tenant could adopt (its tier, not retired). */
        Workspaces_catalog: (input = {}) => call(operations.Workspaces_catalog, input),
        /** Withdraw a scheduled deletion. 404 when none is scheduled, 409 once its date has passed. */
        WorkspaceDeletions_cancel: (input = {}) => call(operations.WorkspaceDeletions_cancel, input),
        /** Schedule the deletion of the tenant and everything it holds, 30 days from now. Idempotent. */
        WorkspaceDeletions_request: (input = {}) => call(operations.WorkspaceDeletions_request, input),
        /** The caller's entitlement snapshot. What the app gates features on. */
        Workspaces_entitlement: (input = {}) => call(operations.Workspaces_entitlement, input),
        /** Ask for an export of everything the tenant holds. 409 while another one is being prepared. */
        WorkspaceExports_create: (input = {}) => call(operations.WorkspaceExports_create, input),
        /** Where an export is; when ready, a download link valid for a few minutes. */
        WorkspaceExports_get: (input) => call(operations.WorkspaceExports_get, input),
    };
}
//# sourceMappingURL=client.js.map